module.exports = __webpack_public_path__ + "static/media/smeGo_color.0d353f4d.svg";